module.exports = __webpack_public_path__ + "static/img/icon3.0c5b069.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon3.png
// module id = y9FJ
// module chunks = 4